<template>
  <div
    class="icon"
    @click="handleClick"
    @mouseleave="handleMouseLeave"
    @mouseover="handleMouseOver"
  >
    <svg
      class="icon__icon"
      :fill="
        mode === 'fill'
          ? hoverColor && hover
            ? hoverColor
            : color
          : 'transparent'
      "
      :stroke="
        mode === 'stroke'
          ? hoverColor && hover
            ? hoverColor
            : color
          : 'transparent'
      "
      :style="{ height, width }"
    >
      <use :href="spriteComputed + '#' + value" />
    </svg>
  </div>
</template>

<script>
/* !!! Copied from base-components to be autonomous !!! */
import IconsSprite from './Icons.svg';

export default {
  name: 'IconEsia',
  props: {
    /* Inapplicable to 'check' icon due to stroke coloring instead of fill.
     * May be inapplicable to similar ones.
     */
    color: { default: 'var(--color-1)', type: String },
    height: { default: '100%', type: String },
    hoverColor: { default: '', type: String },
    // todo: implement 'complex' for complex svg containing different fill and stroke colors
    mode: {
      // 'arrow_up': stroke
      // 'arrow_down': stroke
      // 'arrow_right': stroke
      // 'arrow_left': stroke
      // 'check': predefined,
      // 'code-mode': predefined
      // 'magnifier': fill
      // 'pencil': fill
      // 'plus': fill
      // 'text-mode': predefined
      // 'trash': fill
      // 'zoom-in': fill
      // 'zoom-out': fill
      default: 'fill',
      type: String,
    },
    size: { default: '100%', type: String },
    value: { required: true, type: String },
    width: { default: '100%', type: String },
    sprite: { default: null, type: String },
  },
  emits: {
    click: null,
    mouseleave: null,
    mouseover: null,
  },
  data: () => ({
    hover: false,
  }),
  computed: {
    spriteComputed() {
      return typeof this.sprite === 'string' ? this.sprite : IconsSprite;
    },
  },
  methods: {
    handleClick($event) {
      this.$emit('click', $event);
    },
    handleMouseLeave($event) {
      this.hover = false;
      this.$emit('mouseleave', $event);
    },
    handleMouseOver($event) {
      this.hover = true;
      this.$emit('mouseover', $event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Icon';
</style>
